import React from 'react';
import { useTable } from '../TableContext';
import { cn } from '../../../../utils/cn';

import { useTranslation } from 'react-i18next';

interface TableErrorStateProps {
  error?: Error;
  title?: string;
  message?: string;
  className?: string;
  render?: (props: { columns: number; error?: Error }) => React.ReactNode;
}

export function TableErrorState({
  error,
  title = 'Error',
  message,
  className,
  render,
}: TableErrorStateProps) {
  const { t } = useTranslation('designSystem');
  const { table } = useTable();
  const columns = table.getAllColumns().length;

  if (render) {
    return (
      <tbody>
        <tr>
          <td colSpan={columns}>{render({ columns, error })}</td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      <tr>
        <td
          colSpan={columns}
          className={cn('w-full px-6 py-8 text-center', className)}
        >
          <div className="flex flex-col items-center justify-center">
            <div className="rounded-full bg-red-50 p-3 dark:bg-red-950">
              <svg
                className="h-10 w-10 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-gray-100">
              {title}
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {message ||
                error?.message ||
                t('anErrorOccurredWhileLoadingData')}
            </p>
          </div>
        </td>
      </tr>
    </tbody>
  );
}
